import React, { useEffect, useRef, useState } from 'react'
import { StyledModal } from './style'
import { Util } from 'utils'
import useModalStackStore from 'stores/useModalStackStore'
import useModalStore from 'stores/useModalStore'
import { Button, ButtonProps } from 'components/button/Button/Button'

interface ModalProps {
  title?: string
  children: React.ReactNode
  fitSize?: boolean
  modalToggle: (value: boolean) => void
  height?: string
  maxHeight?: string
  gap?: string
  footerShadow?: boolean
  actionButtons?: ButtonProps[]
  preventEscClose?: boolean
  enterMethod?: () => void
}
/**
 *
 * @param fitSize 내용에 모달 사이즈를 맞춤
 * @returns
 */
function Modal({
  title,
  children,
  modalToggle,
  fitSize,
  height,
  maxHeight,
  footerShadow,
  actionButtons,
  preventEscClose = false,
  enterMethod,
}: ModalProps) {
  // const modalRef = useRef<HTMLDivElement | null>(null);
  const { modalRef } = useModalStore()

  const { addModal, removeModal, getTopModal } = useModalStackStore()

  const [isBodyScrollBar, setIsBodyScrollBar] = useState(false)
  const bodyWrapRef = useRef<HTMLDivElement | null>(null)

  const enterEvent = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && enterMethod) enterMethod()
  }

  const escEvent = (e: KeyboardEvent) => {
    if (preventEscClose) return;

    /** 최상위 모달이 현재 모달일 때만 esc 로 닫히게 */
    if (getTopModal() !== modalRef) {
      return false
    }
    Util.handleKeyPress(e, 'Escape', () => modalToggle(false))
  }

  useEffect(() => {
    addModal(modalRef)
    /** 모달 오픈 시 ESC 버튼으로 모달 닫기 처리 추가 */
    const onPressESCKeyCheck = (event: KeyboardEvent) => {
      /**
       * @description 양희철 - 엔터키 누르면 완료 enterMethod 실행, 함수 없으면 실행 안함
       */
      enterEvent(event)
      escEvent(event)
    }

    document.addEventListener('keydown', onPressESCKeyCheck)
    return () => {
      document.removeEventListener('keydown', onPressESCKeyCheck)
      removeModal(modalRef)
      // modalToggle(false);
    }
  }, [])

  useEffect(() => {
    const checkScrollBar = () => {
      if (bodyWrapRef.current) {
        const hasScrollBar = bodyWrapRef.current.scrollHeight > bodyWrapRef.current.clientHeight
        setIsBodyScrollBar(hasScrollBar)
      }
    }

    // 초기 체크
    checkScrollBar()

    // 윈도우 크기 변경 시에도 체크 (옵션)
    window.addEventListener('resize', checkScrollBar)
    return () => window.removeEventListener('resize', checkScrollBar)
  }, [bodyWrapRef.current])

  return (
    <StyledModal $height={height} $maxHeight={maxHeight}>
      <div
        className="container"
        id={title}
        style={{
          width: fitSize ? 'max-content' : '',
        }}
        ref={modalRef}
      >
        {title && (
          <div className="header-wrap">
            <p className="title">{title}</p>
            <Button
              onClick={() => modalToggle(false)}
              color="strong"
              type="text"
              size="large"
              preIcon="XCloseMd"
            />
          </div>
        )}

        <div
          ref={bodyWrapRef}
          className="body-wrap"
          style={{
            width: fitSize ? 'max-content' : '',
            padding: fitSize ? '0' : '',
            height: '100%',
          }}
        >
          {children}
        </div>
        {actionButtons && actionButtons.length > 0 && (
          <div className={`footer-wrap ${footerShadow || isBodyScrollBar ? 'shadow' : ''}`}>
            {actionButtons.map((button, index) => (
              <Button key={`${button.type}-${index}`} {...button} />
            ))}
          </div>
        )}
      </div>
    </StyledModal>
  )
}
export default Modal
